export default function setHasReachedEnd(context) {
  const meta = context.stores.agentNotificationMeta.get();
  meta.setHasReachedEnd(true);
  context.stores.agentNotificationMeta.set(meta);
}
